var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dataset-page-query-container" },
    [
      _vm.modeQuery === "update" && _vm.querySelected
        ? _c("div", { staticClass: "container-name-query-selected" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/query/query-saved.svg"),
                width: "17"
              }
            }),
            _vm._v("\n    " + _vm._s(_vm.querySelected.name) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modeQuery === "create"
        ? _c("div", { staticClass: "floating-type-query" }, [
            _c(
              "div",
              {
                staticClass: "content-type m__r--10",
                class: { "content-type-active": _vm.query_type === "sql" },
                on: {
                  click: function($event) {
                    _vm.query_type = "sql"
                  }
                }
              },
              [_vm._v("SQL")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.modeQuery === "update" &&
      _vm.querySelected &&
      _vm.querySelected.query_type
        ? _c(
            "div",
            { staticClass: "floating-type-query floating-type-query__update" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.querySelected.query_type === "sql",
                      expression: "querySelected.query_type === 'sql'"
                    }
                  ],
                  staticClass: "content-type m__r--10",
                  class: {
                    "content-type-active":
                      _vm.querySelected.query_type === "sql"
                  }
                },
                [_vm._v("SQL")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("j-monaco-editor", {
        ref: "queryEditor",
        attrs: { value: _vm.dataQuery, language: "sql", height: "200px" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "block-action" }, [
        _c(
          "div",
          {
            staticClass: "btn-blue-query m__r--10",
            on: { click: _vm.actionRunQuery }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/query/run.svg"),
                width: "13"
              }
            }),
            _vm._v("\n      Run Query\n    ")
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hide,
                expression: "hide"
              }
            ],
            staticClass: "btn-grey-query m__r--10",
            on: { click: _vm.openSaveQuery }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/query/save.svg"),
                width: "13"
              }
            }),
            _vm._v("\n      Save Query\n    ")
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-grey-query", on: { click: _vm.openListQuery } },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/icon/query/open.svg"),
                width: "13"
              }
            }),
            _vm._v("\n      Open Saved Query\n    ")
          ]
        ),
        _vm._v(" "),
        _c("label", { staticClass: "label-limit" }, [_vm._v("Limit")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-limit" },
          [
            _c("j-single-select", {
              attrs: {
                options: _vm.options_limit,
                "error-required": false,
                placeholder: "Limit",
                label: "name"
              },
              model: {
                value: _vm.select_limit,
                callback: function($$v) {
                  _vm.select_limit = $$v
                },
                expression: "select_limit"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.opened,
                expression: "opened"
              }
            ],
            staticClass: "popup-query"
          },
          [
            _c(
              "div",
              {
                staticClass: "list-action",
                on: { click: _vm.actionUpdateQuery }
              },
              [_vm._v("Update query")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "list-action",
                on: { click: _vm.openSaveAsQuery }
              },
              [_vm._v("Save as new query")]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showResult
        ? _c(
            "div",
            [
              _c("div", { staticClass: "d-flex p__t--15 p__l--20" }, [
                _c("div", { staticClass: "query-result" }, [
                  _vm._v("Query Result")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-grey-query",
                    on: {
                      click: function($event) {
                        _vm.$refs.saveResultModal.show()
                      }
                    }
                  },
                  [_vm._v("\n        Save Result\n      ")]
                )
              ]),
              _vm._v(" "),
              _c("v-client-table", {
                staticClass: "jTable",
                attrs: {
                  data: _vm.dataResult,
                  columns: _vm.columns,
                  options: _vm.table_options
                },
                scopedSlots: _vm._u([
                  _vm._l(_vm.columns, function(i, index) {
                    return {
                      key: i,
                      fn: function(props) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.cekTypeColumn(i) === "boolean"
                                  ? props.row[i]
                                    ? "true"
                                    : "false"
                                  : props.row[i]
                              ) +
                              "\n      "
                          )
                        ])
                      }
                    }
                  })
                ])
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "saveQueryModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("SAVE NEW QUERY")
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.query_name.$error } },
            [
              _c("label", [_vm._v(" Name ")]),
              _vm._v(" "),
              _c("j-input", {
                attrs: {
                  "error-required": _vm.$v.query_name.$error,
                  "max-length": 255
                },
                model: {
                  value: _vm.$v.query_name.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.query_name, "$model", $$v)
                  },
                  expression: "$v.query_name.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeModalSave }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createNewQuery }
                      },
                      [_vm._v("\n            Save\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "listSavedQueryModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("OPEN SAVED QUERY")
          ]),
          _vm._v(" "),
          _vm.listQuerySaved.length > 0
            ? _c(
                "div",
                { staticClass: "container-list-query-saved" },
                _vm._l(_vm.listQuerySaved, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "list-query",
                      class: {
                        "m__t--10": index > 0,
                        "list-query-active":
                          item.id ===
                          (_vm.querySelected ? _vm.querySelected.id : "")
                      },
                      on: {
                        click: function($event) {
                          _vm.querySelected = item
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icon/query/radio-" +
                            (item.id ===
                            (_vm.querySelected ? _vm.querySelected.id : "")
                              ? "on"
                              : "off") +
                            ".svg"),
                          width: "20"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "m__l--10" }, [
                        _c("div", { staticClass: "label-query" }, [
                          _vm._v(_vm._s(item.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.query_type,
                                  expression: "item.query_type"
                                }
                              ],
                              staticClass: "content-type-query"
                            },
                            [_vm._v(_vm._s(item.query_type))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "id-query" }, [
                            _vm._v("#" + _vm._s(item.id))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "img-delete",
                        attrs: {
                          src: require("@/assets/icon/query/delete.svg"),
                          width: "13"
                        },
                        on: {
                          click: function($event) {
                            _vm.actionDeleteQuery(item)
                          }
                        }
                      })
                    ]
                  )
                })
              )
            : _c("div", [_vm._v("No data option")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeModalListSaved }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        attrs: { disabled: !_vm.querySelected },
                        on: { click: _vm.openQuerySelected }
                      },
                      [_vm._v("\n            Open\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "saveResultModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("SAVE RESULT TO DATASET")
          ]),
          _vm._v(" "),
          _c("label", [_vm._v(" Action ")]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex m__b--10" }, [
            _c(
              "div",
              {
                staticClass:
                  "container-option-save-result result-label d-flex m__r--15",
                class: _vm.typeMode === "merge" ? "option-active" : "",
                on: {
                  click: function($event) {
                    _vm.typeMode = "merge"
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "m__t--3 m__r--5",
                  attrs: {
                    src: require("@/assets/icon/query/merge-data-" +
                      (_vm.typeMode === "merge" ? "on" : "off") +
                      ".svg"),
                    height: "17"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-option" }, [
                  _vm._v("Append Data")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-option-save-result result-label d-flex",
                class: _vm.typeMode === "replace" ? "option-active" : "",
                on: {
                  click: function($event) {
                    _vm.typeMode = "replace"
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "m__t--3 m__r--5",
                  attrs: {
                    src: require("@/assets/icon/query/replace-data-" +
                      (_vm.typeMode === "replace" ? "on" : "off") +
                      ".svg"),
                    height: "17"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-option" }, [
                  _vm._v("Replace Data")
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { class: { "error-input": _vm.$v.data_save_result.group.$error } },
            [
              _c("label", [_vm._v(" Dataset Group ")]),
              _vm._v(" "),
              _c("j-single-select", {
                attrs: {
                  "error-required": _vm.$v.data_save_result.group.$error,
                  options: _vm.datasetGroupOptions,
                  placeholder: "Select Dataset Group",
                  "value-format": "object",
                  label: "name"
                },
                model: {
                  value: _vm.$v.data_save_result.group.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.data_save_result.group, "$model", $$v)
                  },
                  expression: "$v.data_save_result.group.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              class: {
                "error-input": _vm.$v.data_save_result.dataset.$error,
                "m__t--10": !_vm.$v.data_save_result.dataset.$error
              }
            },
            [
              _c("label", [_vm._v(" Dataset ")]),
              _vm._v(" "),
              _c("j-single-select", {
                attrs: {
                  "error-required": _vm.$v.data_save_result.dataset.$error,
                  disabled: !_vm.data_save_result.group,
                  options: _vm.datasetOptions,
                  placeholder: "Select Dataset",
                  "value-format": "object",
                  label: "name"
                },
                model: {
                  value: _vm.$v.data_save_result.dataset.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.data_save_result.dataset, "$model", $$v)
                  },
                  expression: "$v.data_save_result.dataset.$model"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-to-right m__t--15" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn gray m__r--5",
                  on: { click: _vm.closeModalSaveResult }
                },
                [_vm._v("\n        Close\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn blue",
                  attrs: {
                    disabled:
                      !_vm.typeMode ||
                      !_vm.data_save_result.group ||
                      !_vm.data_save_result.dataset
                  },
                  on: { click: _vm.actionSaveResultQuery }
                },
                [_vm._v("\n        Save\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4406b9d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4406b9d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/jDatasetQuery.vue
// module id = null
// module chunks = 